<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
  <div class="navBox"><Nav curNavId="1" pathUrl='gbzntjs' @circle="clickNav"/></div>
  <div class="left flexColumn">
    <div class="leftBox1 flexColumn">
      <div class="title">实时监控</div>
      <div class="videoBox flexColumn">
        <div class="videoBorder" v-if="state.AccessToken!=''">
<!--                        <vue3VideoPlay width="100%" height="100%" title="冰河世纪" src="https://rtmp05open.ys7.com:9188/v3/openlive/K16315021_1_1.flv?expire=1761204032&id=901482734372073472&t=d02628004af6c5e66bce9d8bd0a37a48d72993533cbb54ae3797578028866391&ev=101&supportH265=1"  :autoPlay="true"  :control="false"  :controlBtns="false" />-->
            <iframe
              :src="state.options.src+state.AccessToken"
              width="100%"
              height="100%"
              id="ysOpenDevice"
              allowfullscreen
            >
            </iframe>
        </div>
        <h5>环境监测</h5>
      </div>
    </div>
    <div class="leftBox2 flexColumn">
      <div class="title">土壤肥力监控数据</div>
      <div class="echarts" v-if="state.leftData2.time.length>0"><LeftLine :listData="state.leftData2" /></div>
    </div>
    <div class="leftBox3 flexColumn">
      <div class="title">农药施用记录</div>
      <div class="leftInfo3">
        <txtScroll>
          <div v-for="(item,index) in state.leftData3" :key="index" class="scroll_item">
            <span>{{item.time}}</span>
            <p>{{item.info}}</p>
          </div>
        </txtScroll>
      </div>
    </div>
  </div>
  <div class="right flexColumn">
    <div class="rightBox1 flexColumn">
      <div class="title">高标农田示范区节肥节药量</div>
      <div class="echarts"><RightBar /></div>
    </div>
    <div class="rightBox2 flexColumn">
      <div class="title">生长环境评估</div>
      <div class="echarts"><RightRadar /></div>
    </div>
    <div class="rightBox3 flexColumn">
      <div class="title">虫情报告</div>
      <div class="rightInfo3">
        <div class="imgItem" v-for="(item,index) in state.rightData3" :key="index">
          <div class="imgItemBg"><img :src="item.img" /></div><p>{{item.date}}</p>
        </div>
      </div>

    </div>
  </div>
  <CircleNav :isShow="state.circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/map.json";
import ldt from "../components/gbzntyj/ldt.vue";
import dczz from "../components/gbzntyj/dczz.vue";
import leftBar from "../components/gbzntyj/leftBar.vue";
// import leftPie from "../components/gbzntyj/leftBar.vue";
import footer1 from "@/components/footer.vue";
import txtScroll from "@/components/txtScroll.vue";
import popBg from "@/components/popBg.vue";
import Nav from "@/components/nav.vue";
import LeftLine from "@/components/huanjing/leftLine"
import RightBar from "@/components/huanjing/rightBar"
import RightRadar from "@/components/huanjing/rightRadar"
import CircleNav from "@/components/circleNav"
import {getRandomDate} from "@/utils/getRandomDate";

    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      // options: {
      //   src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/2.live&autoplay=1&accessToken=", //视频源
      //   type: "m3u8", //视频类型
      // },
      options: {
        src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      AccessToken: "",
      imgShow:false,
      leftData2:{
        time:[],value:[68,67,65,63,60,58,55]
      },
      leftData3:[
        {time:"02-27",info:"\"药品1：美丰麦笑（双氟·氯氟吡）+锐耙（2甲4氯钠）+亨达超克（联苯·噻虫嗪）\n" +
            "药品2：酷佬（2甲·双氟·唑）+闪净（联菊·啶虫脒）+恋神奇（碳机硅）\"\n" +
            "多花黑麦草除草剂：美丰瑞丰年（20%甲基二磺隆·异丙隆）+美丰无止境（哗咻草醋）\n" +
            "除草剂、杀虫剂\t12元/亩\t1次\n" +
            "机械\t8元/亩\t\n" +
            "多花黑麦草\t50元/亩\t1次\n" +
            "机械\t8元/亩\t"},
        {time:"03-09",info: "\"药品1：利尔作物·独功（氯氟·毒死蜱）+乐奥多·微量元素水溶肥料+利尔作物·普伴（24-表芸苔素内脂）+赛都优（氨基寡糖素）\n" +
              "药品2：六夫丁·快守（高效氯氟氰菊酯）+澳佳·活力丰（腐殖酸钾）+佳运（24-表芸苔素内脂）+优植康·清辞（寡糖·吗胍）\"\n" +
            "一喷三防\t18元/亩/次\t1次"},
        {time:"05-05",info:"氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素内酯）"},
      ],
      rightData3:[
        {date:"2024.4.18",img:require("@/assets/img/gbzntyj/bingchong/cq1.jpg")},
        {date:"2024.4.20",img:require("@/assets/img/gbzntyj/bingchong/cq2.jpg")},
        {date:"2024.4.26",img:require("@/assets/img/gbzntyj/bingchong/cq3.jpg")},
        {date:"2024.4.30",img:require("@/assets/img/gbzntyj/bingchong/cq4.jpg")},
        {date:"2024.5.03",img:require("@/assets/img/gbzntyj/bingchong/cq5.jpg")},
        {date:"2024.5.06",img:require("@/assets/img/gbzntyj/bingchong/cq6.jpg")}
      ],
      circleShow:false
    });

    const emit = defineEmits(["mapLoad"]);
    const boundaryData = Gep;

    const marker = ref();
    const map = ref(null);
    let current = ref(0);

    // 地图底图
    // 第一种
    let mapType = ref("vec");
    let mapLabelType = ref("cva");

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    // let mapType1 = ref(
    //   L.tileLayer(
    //     "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );
    let mapType1 = ref(
      L.tileLayer(
        "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    let mapLabelType1 = ref(
      L.tileLayer(
        "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
        }
      )
    );
    // let mapLabelType1 = ref(
    //   L.tileLayer(
    //     "https://t{s}.tianditu.gov.cn/" +
    //       "cva" +
    //       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
    //       "cva" +
    //       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    //     {
    //       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    //     }
    //   )
    // );

    const initMap = () => {
      map.value.addLayer(mapType1.value);
      map.value.addLayer(mapLabelType1.value);
      map.value.on("click", ({ latlng }) => {
        console.log("坐标：", Object.values(latlng));
      });

      return map.value;
    };

    const mapObj = ref();

    // 在 onMounted 中初始化地图
    onMounted(() => {
      // 获取视频AccessToken
      state.AccessToken = localStorage.getItem("AccessToken");
      // console.log(state.AccessToken);
      const text = "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。";
      state.textList = chunkString(text, 44);
      // 左侧肥力时间
      let dateArr = getDate(6,3,'feili')
      // console.log(dateArr)
      state.leftData2.time = dateArr
      // 虫情检测时间
      let dateArr1 = getDate(6,2,'binghaiDate2')
      // console.log(dateArr1)
      for(var i=0;i<state.rightData3.length;i++){
        // console.log(data[i])
        state.rightData3[i].date = dateArr1[i]
      }


      map.value = L.map(mapRef.value, {
        center: [33.248258780732435, 114.18800353654662],

        // center: [114.182633, 33.240019],
        zoom: 13,
        minZoom: 3,
        maxZoom: 19,
        noWrap: true,
        // dragging: false,
        zoomControl: true,
        attributionControl: false,
      });
      mapObj.value = initMap();
      // createMarkers();
      loadBoundary();
      for (const markerDatum of markersData) {
        for (const latlng of markerDatum.locations) {
          const iconPath = require(`../assets/img/icon/${markerDatum.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48], // 图标大小
              iconAnchor: [22, 94], // 图标锚点
              popupAnchor: [-3, -76], // 弹出窗锚点
            }),
          });

          // 假设没有针对每个点定制的弹出内容，可以根据需求添加
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
          //   markerDatum.title ? markerDatum.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    });
    // 新增一个清除所有标记的方法
    function clearMarkers() {
      // 如果map.value存在并且有layers，则遍历删除所有标记
      if (map.value && map.value.eachLayer) {
        map.value.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            map.value.removeLayer(layer);
          }
        });
      }
    }
    // 假设有个按钮点击事件，用buttonClick表示
    function buttonClick(index) {
      // 清除所有已存在的标记
      clearMarkers();

      // 筛选出iconName为"1.png"的标记数据
      const filteredMarkers = markersData.find(
        (markerDatum) => markerDatum.iconName === index + ".png"
      );

      // 遍历筛选出来的标记数据，添加到地图上
      if (filteredMarkers) {
        for (const latlng of filteredMarkers.locations) {
          const iconPath = require(`../assets/img/icon/${filteredMarkers.iconName}`);

          const marker = createAndAddMarker(latlng, {
            title: `地标`,
            icon: L.icon({
              iconUrl: iconPath,
              iconSize: [34, 48],
              iconAnchor: [22, 94],
              popupAnchor: [-3, -76],
            }),
          });

          // 添加自定义的弹出内容
          // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
          //   filteredMarkers.title ? filteredMarkers.title : "地标"
          // }</div>`;
          // marker.bindPopup(popupContent);
        }
      }
    }

    // 定义一个函数用来创建和添加Marker
    function createAndAddMarker(latlng, options = {}) {
      const marker = L.marker(latlng, options);
      marker.addTo(map.value);
      return marker;
    }
const markersData = [
  {
    locations: [
      [33.24496,114.19039],
      [33.24967044852794, 114.184255599975],
      [33.24249222503867, 114.18322563171388],
    ],
    iconName: "sc.png",
    // 其他相关属性...
  },

];

    function createDashedPolyline(feature, style) {
      const latLngs = feature.geometry.coordinates;
      if (feature.geometry.type === "Polygon") {
        // 取外圈线作为多段线处理
        latLngs = [latLngs[0]];
      } else if (feature.geometry.type === "MultiPolygon") {
        // 处理多个多边形，这里仅取第一个外圈线
        latLngs = [latLngs[0][0]];
      }

      const options = {
        ...style,
        dashArray: [5, 5], // 虚线长度与间距
        lineCap: "round", // 线头样式，可选
        lineJoin: "round", // 线交接处样式，可选
      };

      return L.polyline(latLngs, options);
    }

    // 添加行政区划边界的逻辑
    const loadBoundary = () => {
      L.geoJSON(boundaryData, {
        onEachFeature: function (feature, layer) {
          let style;

          switch (feature.properties.T) {
            case "未建成":
              style = {
                color: "#F4E60C",
                fillColor: "#F4E60C",
                fillOpacity: 0.25,
                dashArray: [0, 0],
                weight: 0,
              };
              break;
            case "其他":
              style = {
                color: "#F4E60C",
                fillColor: "#F4E60C",
                fillOpacity: 0.25,
                dashArray: [0, 0],
                weight: 0,
              };
              break;
            default:
              style = {
                color: "#67E94B",
                fillColor: "#F4E60C",
                fillOpacity: 0.25,
                dashArray: [0, 0],
                weight: 1,
              };
          }

          if (
            feature.geometry.type === "Polygon" ||
            feature.geometry.type === "MultiPolygon"
          ) {
            // 设置填充样式
            layer.setStyle(style);

            // 处理每个外环线为虚线
            feature.geometry.coordinates.forEach((ring, index) => {
              if (index === 0 || feature.geometry.type === "Polygon") {
                // 对于多边形，只处理外环线
                const dashedLine = createDashedPolyline(
                  { geometry: { coordinates: [ring] } },
                  style
                );
                map.value.addLayer(dashedLine);
              }
            });
          } else if (
            feature.geometry.type === "LineString" ||
            feature.geometry.type === "MultiLineString"
          ) {
            const dashedLine = createDashedPolyline(feature, style);
            map.value.addLayer(dashedLine);
          }

          // 添加原始图层到地图上（用于显示填充区域）
          map.value.addLayer(layer);
        },
      }).addTo(map.value);
    };

    const removeMap = () => {
      if (mapObj.value) {
        mapObj.value.remove();
      }
    };



    
    function chunkString(str, chunkSize) {
      if (str.length <= chunkSize) {
        return [str];
      }
      return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
    }
    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
const clearLocalStorage = (name) => {
  localStorage.removeItem(name);
  console.log("清除")
};
let intervalId = null;
    function getDate(numDays,type,name){
      console.log(type)
      let dateArr=[]
      let recentDate = localStorage.getItem(name);
      // console.log(recentDate)
      if(recentDate){
        dateArr = recentDate.split(',')
      }else{
        const daysAgo = ref(numDays,type);
        const recentDate = getRandomDate(daysAgo.value,type);
        // console.log(recentDate)
        localStorage.setItem(name, recentDate);
        // console.log(localStorage.getItem(name))
        intervalId = setInterval(clearLocalStorage(name), 3 * 24 * 60 * 60 * 1000);
        dateArr = recentDate
      }
      return dateArr
    }
    onUnmounted(() => {
      removeMap();
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}


.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 150px;
  background: linear-gradient( to bottom, rgba(3, 14, 25, 1) 0%,  rgba(3, 14, 25, 0.7) 60%,  rgba(3, 14, 25, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.flexColumn{
  display: flex;
  flex-direction: column;
}
.echarts{
  width: 100%;
  flex: 1;
}
.title{
  width:100%;
  height: 40px;
  font-weight: bold;
  background: url("../assets/img/huanjing/xbt.png") no-repeat left bottom;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  text-align: left;
  padding-left: 30px;
}
.left,.right{
  position: fixed;
  top: 100px;
  width: 432px;
  height: calc(100% - 120px);
  background: url("../assets/img/huanjing/ck.png") no-repeat;
  background-size: 100% 100%;
  z-index: 1000;
  padding: 20px 0;
}

.left{
  left: 10px;
  .leftBox1{
    height: 324px;
    align-items: center;
    .videoBox{
      width: 370px;
      height: 226px;
      background: url("../assets/img/huanjing/jkk.png") no-repeat;
      margin-top: 20px;
      padding: 15px 23px 3px 25px;
      .videoBorder{
        width: 100%;
        height: 100%;
        //border: 1px solid #f00;
      }
      h5{
        line-height: 33px;
        color: #fff;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
  .leftBox2{
    flex: 1;
  }
  .leftBox3{
    height: 345px;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 14px;
    .leftInfo3{
      width: 370px;
      height: 279px;
      background: url("../assets/img/huanjing/ny.png") no-repeat;
      padding: 10px 20px;
      ::v-deep .main_container{
        height: 239px;
      }
      .scroll_item{
        //height: 180px;
        text-align: left;

        span{
          display: block;
          color: #FFA011;
          font-size: 16px;
          line-height: 30px;
          height: 30px;
        }
        p{
          font-size: 14px;
          color: #fff;
          line-height: 24px;
        }
      }
    }
  }
}
.right{
  right: 10px;
  .rightBox1{
    width: 100%;
    flex: 1;
  }
  .rightBox2{
    height: 282px;
  }
  .rightBox3{
    height: 352px;
    .rightInfo3{
      width: 100%;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 24px 10px 0;
      .imgItem{
        width: 129px;
        height: 127px;
        .imgItemBg{
          width:127px ;
          height: 97px;
          background: url("../assets/img/huanjing/cq.png") no-repeat ;
          padding: 4px 11px 4px 14px;
          img{
            width: 100%;
            height: 100%;
            display: block;
          }
        }
          p{
            color: #fff;
            font-size: 14px;
            line-height: 30px;
          }
        }
    }
  }
}


</style>
